module.exports = __webpack_public_path__ + "img/diamond-4-no-shine.321f4481.png";